;(function (angular, _) {
  'use strict'

  angular.module('kilo.common.directives')
    .directive('zlImgUploader', UploaderDirective)

  UploaderController.$inject = ['$scope', 'urls', 'zlAuth', 'FileUploader', 'FileManager', 'SessionService']

  function UploaderController ($scope, urls, zlAuth, FileUploader, FileManager, SessionService) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        company: SessionService.getCompany(),
        uploader: uploader,
        clearImage: clearImage,
        getUrl: getUrl,
      })
    }

    var uploader = new FileUploader({
      url: urls.uploader + '/upload',
      autoUpload: true,
      alias: 'files',
      withCredentials: false
    })

    zlAuth.getToken().then(function (tokn) {
      uploader.headers = { 'Authorization': 'Bearer ' + tokn }
    })

    function clearImage () {
      self.zlModel = false
      $scope.$emit('formModified')
    }

    uploader.onCompleteItem = function (fileItem, response) {
      self.zlModel = FileManager.create(response[0])
      $scope.$emit('formModified')
    }

    uploader.onCompleteAll = function () {
      uploader.clearQueue()
    }

    function getUrl () {
      if (!self.zlModel) {
        return '/assets/images/default.png'
      }
      return urls.downloader + '/image/' + self.company + '/' + (self.zlModel._id || self.zlModel)
    }
  }

  UploaderDirective.$inject = []

  function UploaderDirective () {
    return {
      restrict: 'E',
      require: 'ngModel',
      templateUrl: '/app/common/directives/image-uploader/image-uploader.directive.template.html',
      controllerAs: 'uploader',
      controller: UploaderController,
      scope: {},
      bindToController: {
        zlModel: '='
      }
    }
  }
})(window.angular, window._)
